export default "__VITE_ASSET__9w4smEjNx6ecdUwZL_UOCw__"